module.exports = __webpack_public_path__ + "static/img/Russell.716b387.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Russell.jpg
// module id = 6xZp
// module chunks = 1